'use strict';

var React = require('react');

var SvgInsertDynamicSourceMinor = function SvgInsertDynamicSourceMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 9c3.866 0 7-1.343 7-3s-3.134-3-7-3-7 1.343-7 3 3.134 3 7 3Zm3.278 1.651a6.028 6.028 0 0 0-2.464 2.329c-.267.013-.539.02-.814.02-3.866 0-7-1.343-7-3 0-.35.14-.687.398-1 .961 1.165 3.554 2 6.602 2 1.185 0 2.3-.126 3.278-.349Zm-3.278 5.349v1c-3.866 0-7-1.343-7-3 0-.35.14-.687.398-1 .961 1.165 3.554 2 6.602 2h.083c-.055.325-.083.66-.083 1Zm5 2a1 1 0 0 1-1-1v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 1 1 0 2h-1v1a1 1 0 0 1-1 1Z"
  }));
};

exports.SvgInsertDynamicSourceMinor = SvgInsertDynamicSourceMinor;
